import { LicenseManager } from "ag-grid-enterprise";

/**
 * Initializes the AG Grid Enterprise license.
 *
 * The actual license key should be provided via the
 * `VITE_AG_GRID_LICENSE_KEY` environment variable.
 *
 * Example:
 * VITE_AG_GRID_LICENSE_KEY="your-enterprise-license-key"
 */
export function initAgGridLicense(licenseKey: string) {
  if (!licenseKey) {
    console.error("Ag Grid license key is not set");
    return;
  }

  LicenseManager.setLicenseKey(licenseKey);
}

